export const SET_ERROR = "security.set.error";
